module.exports = __webpack_public_path__ + "static/jekyll-0887875dd85dcd31c04cbab3feac9e29.svg";